import { pagesConfig } from '../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import Box from '@mui/material/Box';
import { DETAIL_VIEWS_BREADCRUMBS } from './detail-view-utils';

export default function IamMemberSummaryPage() {
  const BREADCRUMBS = [
    ...DETAIL_VIEWS_BREADCRUMBS,
    { label: pagesConfig.insightsIamMemberSummary.name },
  ];

  return (
    <SimpleBreadcrumbsPage breadcrumbs={BREADCRUMBS} shouldAllowHeightToScroll>
      <Box p={1}></Box>
    </SimpleBreadcrumbsPage>
  );
}
